module.exports = __webpack_public_path__ + "img/car_00055.0e17950f.jpg";